<template>
  <div id="app"
       v-if="!isrefresh">
    <router-view />
    <div class="el-loading-mask"
         style="background: rgba(0, 0, 0, 0.7); z-index: 99999999999999"
         v-if="animate">
      <div class="el-loading-spinner">
        <i class="el-icon-loading"></i>
        <p class="el-loading-text">请求加载中...</p>
      </div>
    </div>
    <!-- <div style="width:100%;height:100%;display:flex;align-item:center;justify-content: center;" v-cloak>
      <img src="../public/loading/loading-animation.gif" alt="">
    </div> -->
    <!-- <el-backtop :bottom="bottom"></el-backtop> -->
    <div class="updatePsw"
         v-if="showUpdatePsw">
      <div class="content">
        <div class="header">修改个人信息
        </div>
        <el-form :model="myform"
                 ref="myform"
                 :rules="rules">
          <el-form-item label="昵称"
                        label-width="80px"
                        prop="name">
            <el-input v-model="myform.name"
                      placeholder="必填，2-10个字"></el-input>
          </el-form-item>
          <el-form-item label="手机"
                        label-width="80px"
                        prop="mobile">
            <el-input v-model="myform.mobile"
                      placeholder="请输入11位手机号"></el-input>
          </el-form-item>
          <el-form-item label="邮箱"
                        label-width="80px"
                        prop="email">
            <el-input v-model="myform.email"
                      placeholder="必填，不超过60个字"></el-input>
          </el-form-item>
          <el-form-item label="新密码"
                        label-width="80px"
                        prop="newpsw">
            <el-input v-model="myform.newpsw"
                      placeholder="8-16字，密码应包含大小写字母，数字，特殊字符，请尽量复杂！"></el-input>
          </el-form-item>
        </el-form>
        <div class="footer">
          <el-button type="primary"
                     :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                     @click="submit('myform')">提 交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSsoConfig } from "@/api/config";
import getSimple from "@/constants/simple";
import { updateUser, setOffline } from "@/api/user";
import { mapGetters, mapActions } from "vuex";
import axios from "axios"
import Vue from 'vue'
export default {
  data () {
    return {
      animate: false,
      timer: null,
      bottom: 90,
      isrefresh: true,
      showUpdatePsw: false,
      myform: {
        id: 60000,
        name: "",
        mobile: "",
        email: "",
        newpsw: "",
        sort: 0,
        status: 0,
        userType: 0,
        roleIds: ''
      },
      rules: {
        name: [
          { required: true, message: "请输入昵称", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
        ],
        mobile: [
          { required: true, message: "请输入手机", trigger: "blur" },
          { min: 11, max: 11, message: "长度在 11 个字符", trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' },
          { min: 2, max: 60, message: "长度不超过 60 个字符", trigger: "blur" }
        ],
        newpsw: [
          { min: 8, max: 16, message: "长度在 8 到 16 个字符", trigger: "blur" }
        ]
      }
    };
  },

  computed: {
    ...mapGetters(["loginInfo"]),
    loading () {
      return this.$store.state.loading;
    }
  },

  watch: {
    '$store.state.user.isChangePsw' (newVal, oldVal) {
      if (newVal) {
        this.showUpdatePsw = true;
        // console.log(this.loginInfo);
        // this.myform.id = this.loginInfo.id
        this.myform.name = this.loginInfo.name
        this.myform.mobile = this.loginInfo.mobile
        this.myform.email = this.loginInfo.email
        this.myform.id = this.loginInfo.id
        // this.myform.password = this.$md5(this.loginInfo.password) || this.$md5("123456")
        this.myform.status = this.loginInfo.status
        this.myform.sort = this.loginInfo.sort
        this.myform.userType = this.loginInfo.userType
        this.myform.roleIds = this.loginInfo.roleIds || '1'
      }
    },
    loading (loading) {
      // 这里使用了节流
      const that = this;
      var throttle = function (func, delay) {
        var startTime = Date.now();
        return function () {
          var curTime = Date.now();
          var remaining = delay - (curTime - startTime);
          var context = this;
          var args = arguments;
          clearTimeout(that.timer);
          if (remaining <= 0) {
            func.apply(context, args);
            startTime = Date.now();
          } else {
            that.timer = setTimeout(func, remaining);
          }
        };
      };
      function handle () {
        that.animate = loading;
      }

      throttle(handle, 400)();
    },
  },
  methods: {
    ...mapActions(["setLoginInfo"]),
    submit (form) {
      // if (this.myform.newpsw != "") {
      let pswRegex = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,16}')
      if (!pswRegex.test(this.myform.newpsw)) {
        // this.$message.warning('密码包含大写字母，小写字母，数字，特殊字符！')
        this.$message({
          message: '密码需包含大写字母，小写字母，数字，特殊字符！',
          type: 'warning',
          duration: 5000,
          customClass: 'messageIndex'
        })
        return
      }
      // }
      this.$refs[form].validate(valid => {
        if (valid) {
          if (this.myform.newpsw) {
            this.myform.password = this.$md5(this.myform.newpsw)
          }
          console.log(this.myform)
          this.updateUserAsync(this.myform)
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //修改个人信息
    async updateUserAsync (val) {
      let { status, data, message, errors } = await updateUser(val);
      if (status) {
        this.setLoginInfo(data)
        this.showUpdatePsw = false;
        this.$message.success("修改成功！");
        await setOffline(data.id)
        this.beSure()
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message({
          message: message + errortext,
          type: 'error',
          customClass: 'messageIndex'
        });
      }
    },
    beSure () {
      localStorage.removeItem("loginInfo");
      localStorage.removeItem("powers");
      sessionStorage.removeItem("roleCode");
      localStorage.removeItem("createUid");
      localStorage.removeItem("token");
      localStorage.removeItem("firstPage");
      sessionStorage.removeItem("picLove");

      setTimeout(() => {
        // location.reload();
        this.$router.push("/login");
      }, 888);
    },
    async getSsoConfigAsync () {

      // if (window.location.pathname == "/" || window.location.pathname == "/login") {
      // setTimeout(() => {
      if (window.location.pathname == "/loginNoToken") {
        setTimeout(() => {
          this.isrefresh = false
        }, 1500);
        return
      } else {
        setTimeout(() => {
          this.isrefresh = false
        }, 88);
        await getSsoConfig()
      }
      // }, 200);
    },

    async checkIsUpdate () {
      await axios({
        headers: {
          Authorization: JSON.parse(localStorage.getItem('token')),
        },
        method: "get",
        url: `/api/lib/listLib`
      })
        .then((res) => {
        })
        .catch((error) => {
          if (error.response.status === 503 || error.response.status === 502) {
            this.$router.push('/renewal')
          }
        });
    },
  },
  created () {

    if (localStorage.getItem('token')) {
      let localToken = localStorage.getItem('token')
      if (localToken.indexOf('"') == -1) {
        localStorage.setItem('token', JSON.stringify(localToken))
      }
    }

    this.checkIsUpdate()


    this.isrefresh = true
    if (typeof (localStorage.getItem('isSimple')) == "string") {
      Vue.prototype.isSimple = JSON.parse(localStorage.getItem('isSimple'))
    } else {
      if (localStorage.getItem('isSimple') == true) {
        Vue.prototype.isSimple = localStorage.getItem('isSimple')
      } else if (localStorage.getItem('isSimple') == false) {
        Vue.prototype.isSimple = localStorage.getItem('isSimple')
      }
    }

    //简易版
    getSimple().then(res => {
      if(res.isCustom){
        Vue.prototype.isCustom = res.isCustom
        Vue.prototype.customColor = res.customColor
        Vue.prototype.custom = res.custom
      }else{
        Vue.prototype.isCustom = false
        Vue.prototype.customColor = res.customColor
        Vue.prototype.custom = res.custom
      }
      if (typeof (res.isSimple) !== "undefined") {
        Vue.prototype.isSimple = res.isSimple
      } else {
        Vue.prototype.isSimple = true
      }
      // Vue.prototype.isSimple = false

      localStorage.setItem('isSimple', Vue.prototype.isSimple)
      localStorage.setItem('isCustom', Vue.prototype.isCustom)
      localStorage.setItem('customColor', Vue.prototype.customColor)
      localStorage.setItem('custom', Vue.prototype.custom)
      this.isrefresh = false
    })
    let flag = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)
    if (!flag) {
      this.getSsoConfigAsync()
    } else {
      this.isrefresh = false
    }

    if (sessionStorage.getItem('isChangePsw') == 'true' && this.loginInfo) {
      this.showUpdatePsw = true
      this.myform.name = this.loginInfo.name
      this.myform.mobile = this.loginInfo.mobile
      this.myform.email = this.loginInfo.email
      // this.myform.password = this.$md5(this.loginInfo.password) || this.$md5("123456")
      this.myform.status = this.loginInfo.status
      this.myform.sort = this.loginInfo.sort
      this.myform.id = this.loginInfo.id
      this.myform.userType = this.loginInfo.userType
      this.myform.roleIds = this.loginInfo.roleIds || '1'
    }
  }
};
</script>
<style>
/* @import './assets/font/font.css'; */

* {
  margin: 0;
  padding: 0;
  /* user-select: none; */
  font-family: Ariai, Microsoft YaHei;
}
/* [v-cloak] {
  display: none;
} */
ul,
li {
  list-style: none;
}

.el-table__header .has-gutter /deep/ .cell {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.el-table__body /deep/ .cell {
  font-size: 13px;
  color: #333;
}

.el-dialog /deep/ .el-button--primary {
  background: #185ed3;
  border-color: #185ed3;
}

.cell /deep/ .el-button--text {
  color: #333333;
}

#app /deep/ .el-dialog__wrapper {
  transition-duration: 0.3s;
}
#app /deep/ .dialog-fade-enter-active {
  animation: none !important;
}
#app /deep/ .dialog-fade-leave-active {
  transition-duration: 0.15s !important;
  animation: none !important;
}

#app /deep/ .dialog-fade-enter-active .el-dialog,
#app /deep/ .dialog-fade-leave-active .el-dialog {
  animation-fill-mode: forwards;
}

#app /deep/ .dialog-fade-enter-active .el-dialog {
  animation-duration: 0.3s;
  animation-name: anim-open;
  animation-timing-function: cubic-bezier(0.6, 0, 0.4, 1);
}

#app /deep/ .dialog-fade-leave-active .el-dialog {
  animation-duration: 0.3s;
  animation-name: anim-close;
}

#app /deep/ .el-loading-mask {
  z-index: 88;
}

@keyframes anim-open {
  0% {
    opacity: 0;
    transform: scale3d(0, 0, 1);
  }
  100% {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}

@keyframes anim-close {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: scale3d(0.5, 0.5, 1);
  }
}

body /deep/ .el-picker-panel,
body /deep/ .el-select-dropdown,
body /deep/ .el-message-box__wrapper {
  z-index: 10003 !important;
}
.el-select-dropdown /deep/ .el-select-dropdown__empty {
  width: 364px;
}

.el-tabs /deep/ .is-active {
  color: #383838 !important;
  font-weight: bolder !important;
}
.el-tabs /deep/ .el-tabs__item:hover {
  color: #383838 !important;
  font-weight: bolder !important;
}

.myPriConfirm {
  border: none;
  background: #185ed3 !important;
}
.mySimplePriConfirm {
  border: none !important;
  background: #fd9112 !important;
}

.xgfirm{
  border: none;
  background: #074CA1 !important;
}
.wcfirm{
  border: none;
  background: #042A72 !important;
}

input:focus {
  border-style: solid !important;
  border-color: #b9b9b9 !important;
}
textarea:focus {
  border-style: solid !important;
  border-color: #b9b9b9 !important;
}
/* #nprogress .bar {
  background: green !important; 
} */
.updatePsw {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9998;
  box-sizing: border-box;
}
.updatePsw .content {
  width: 32%;
  background: white;
  margin: auto;
  margin-top: 200px;
  height: auto;
  min-height: 36vh;
  border-radius: 10px;
  padding: 0 40px 20px 20px;
}
.updatePsw .content .header {
  height: 60px;
  padding: 20px 20px 60px 20px;
  box-sizing: border-box;
}
.updatePsw .content .footer {
  text-align: right;
}
.messageIndex {
  z-index: 9999 !important;
}

/* #nprogress .bar {
  background: red !important; 
} */
</style>
